/*
 * About Data SKUs: https://developers.google.com/places/web-service/usage-and-billing
 */
export var basic = ['address_component', 'adr_address', 'alt_id', 'formatted_address', 'geometry', 'icon', 'id', 'name', 'permanently_closed', 'photo', 'place_id', 'scope', 'type', 'url', 'user_ratings_total', 'utc_offset', 'vicinity'];
export var contact = ['formatted_phone_number', 'international_phone_number', 'opening_hours', 'website'];